import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { bookingShape } from 'constants/propTypes';
import ForcedCancellationModal from 'components/shared/ForcedCancellationModal';
import { StyledActionButton } from '../CancelSpecificBookingItemsCta.styles';

const ForcedCancellation = ({
  isModalVisible,
  isDisabled,
  isLoading,
  toggleModal,
  onSubmit,
  selectedItemRefs,
  booking,
  mergeThirdPartyModal = false
}) => (
  <>
    <StyledActionButton disabled={isDisabled} data-cy="open-forced-refund-button" onClick={toggleModal} data-testid="cancel-button">
      <FormattedMessage id="manageBooking.cancelRefund" />
    </StyledActionButton>

    <ForcedCancellationModal
      isOpen={isModalVisible}
      onToggle={toggleModal}
      onSubmit={onSubmit}
      isLoading={isLoading}
      selectedItemRefs={selectedItemRefs}
      booking={booking}
      mergeThirdPartyModal={mergeThirdPartyModal}
    />
  </>
);

ForcedCancellation.propTypes = {
  isModalVisible: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  toggleModal: PropTypes.func,
  onSubmit: PropTypes.func,
  booking: bookingShape,
  selectedItemRefs: PropTypes.arrayOf(PropTypes.string),
  mergeThirdPartyModal: PropTypes.bool
};

export default ForcedCancellation;
